/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { DefaultContainerLayout } from '@/data/types/ContainerLayout';

const Layout: DefaultContainerLayout = {
	id: '12503',
	name: 'ProductListingPageLayout',
	containerName: 'product-listing-page',
	isStoreDefault: true,
	slots: [
		{
			id: '1',
			widgets: [
				{
					widgetName: 'breadcrumb-trail-widget',
					sequence: 0,
					name: 'BreadcrumbTrail',
				},
			],
		},
		{
			id: '2',
			widgets: [
				{
					id: '',
					name: 'category-navigation-widget-rv',
					widgetName: 'category-navigation-widget-rv',
					sequence: 1.0,
				},
				{
					id: '3013',
					name: 'FacetNavigation',
					widgetName: 'facet-navigation-widget',
					sequence: 2.0,
				},
			],
		},
		{
			id: '3',
			widgets: [
				{
					id: 'search',
					name: 'CatalogEntryList',
					widgetName: 'catalog-entry-list-widget',
					sequence: 0.0,
				},
			],
		},
	],
};

export default Layout;
